<div class="container">
    <div class="row">
        <h2>Ingreso Representante Legal.</h2>
    </div>
    <div class="row mb-3">
        <p class="lead">
            Ingrese rut de empresa a la cual asignar representate legal.
        </p>
    </div>
    <form class="row g-3" autocomplete="off" [formGroup]="formulario" (ngSubmit)="inserteRepr();" >
        <div class="mb-3 col-6">
            <label for="rut" class="form-label">Rut Empresa</label>
            <div class="input-group">
                <div class="col-auto"><input formControlName="rut" id="rut" class="form-control"></div> <span class="input-group-text">-</span> <div class="col-1"><input formControlName="dv" id="dv" class="form-control"></div>
            </div>
            <div id="rutHelp" class="form-text">Ingresa rut de Empresa a la cual se asignará el representante legal.</div>
        </div>
        <div class="mb-3 col-6">
            <label for="razonSocial" class="form-label">Razón Social</label>
            <input formControlName="razonSocial" id="razonSocial" class="form-control">
            <div id="razonSocialHelp" class="form-text">Ingresa razon social.</div>
        </div>
        <div class="mb-3 col-6">
            <label for="fechaIngreso" class="form-label">Fecha Ingreso</label>
            <input formControlName="fechaIngreso" id="fechaIngreso" class="form-control">
            <div id="fechaIngresoHelp" class="form-text">Ingresa razon social.</div>
        </div>
        <div class="mb-3 col-6">
            <!-- <label for="fechaIngreso" class="form-label">Fecha Ingreso</label>
            <input formControlName="fechaIngreso" id="fechaIngreso" class="form-control">
            <div id="fechaIngresoHelp" class="form-text">Ingresa razon social.</div> -->
        </div>
        <span class="border-bottom border-dark"></span>
        <div class="mb-3 col-12">
            <div class="col-6">
                <label for="rutRep" class="form-label">Rut Representante</label>
                <div class="input-group">
                    <div class="col-auto"><input formControlName="rutRep" id="rutRep" class="form-control"></div> <span class="input-group-text">-</span> <div class="col-1"><input formControlName="dvRep" id="dvRep" class="form-control"></div>
                </div>
                <div id="rutRepHelp" class="form-text">Ingresa rut del representante legal.</div>
            </div>
        </div> 
        <div class="mb-3 col-6">
            <label for="nombreRep" class="form-label">Nombres Representante</label>
            <input formControlName="nombreRep" id="nombreRep" class="form-control">
            <div id="nombreRepHelp" class="form-text">Nombre del Representante.</div>
        </div>
        <div class="mb-3 col-6">
            <label for="apePater" class="form-label">Apellido Paterno</label>
            <input formControlName="apePater" id="apePater" class="form-control">
            <div id="apePaterHelp" class="form-text">Nombre del Representante.</div>
        </div>
        <div class="mb-3 col-12">
            <div class="col-6">
                <label for="apeMater" class="form-label">Apellido Materno</label>
                <input formControlName="apeMater" id="apeMater" class="form-control">
                <div id="apeMaterHelp" class="form-text">Nombre del Representante.</div>
            </div>
        </div>
        <div class="mb-3 col-6">
            <label for="correoRep" class="form-label">Correo Electrónico</label>
            <input formControlName="correoRep" id="correoRep" class="form-control">
            <div id="correoRepHelp" class="form-text">Nombre del Representante.</div>
        </div>
        <div class="mb-3 col-6">
            <label for="correoRepCon" class="form-label">Correo Confirmación</label>
            <input formControlName="correoRepCon" id="correoRepCon" class="form-control">
            <div id="correoRepConHelp" class="form-text">Nombre del Representante.</div>
        </div>
        <div class="mb-3 col-2">
            <label for="fonoArea" class="form-label">Aréa de Telefono</label>
            <input formControlName="fonoArea" id="fonoArea" class="form-control">
            <div id="fonoAreaHelp" class="form-text">Nombre del Representante.</div>
        </div>
        <div class="mb-3 col-4">
            <label for="fono" class="form-label">Telefono</label>
            <input formControlName="fono" id="fono" class="form-control">
            <div id="fonoHelp" class="form-text">Nombre del Representante.</div>
        </div>
        <div class="mb-3 col-2">
            <label for="celuArea" class="form-label">Aréa de Celular</label>
            <input formControlName="celuArea" id="celuArea" class="form-control">
            <div id="celuAreaHelp" class="form-text">Nombre del Representante.</div>
        </div>
        <div class="mb-3 col-4">
            <label for="celu" class="form-label">Celular</label>
            <input formControlName="celu" id="celu" class="form-control">
            <div id="celuHelp" class="form-text">Nombre del Representante.</div>
        </div>
        <div class="mb-3 col-6" *ngIf="this.formulario.get('rut').value>=50000000">
            <label for="certf1" class="form-label">Certificado 1</label>
            <div class="input-group mb-3">
                <input type="file" class="form-control" id="certf1" (change)="fileCert1($event)" formControlName="certf1" accept=".pdf">
            </div>
        </div>
        <div class="mb-3 col-6" *ngIf="this.formulario.get('rut').value>=50000000">
            <label for="certf2" class="form-label">Certificado 2</label>
            <div class="input-group mb-3">
                <input type="file" class="form-control" id="certf2" (change)="fileCert2($event)" formControlName="certf2" accept=".pdf"> 
            </div>
        </div>
        <div class="mb-3 col-2">
            <button type="submit" class="btn btn-primary">Aceptar</button>
        </div>
    </form>
</div>
